import { createIcon } from '../create-icon'

export const TrophyCup = createIcon('TrophyCup', ({ strokeWidth }) => (
  <>
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" strokeWidth={strokeWidth} />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" strokeWidth={strokeWidth} />
    <path d="M4 22h16" strokeWidth={strokeWidth} />
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20 7 22" strokeWidth={strokeWidth} />
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20 17 22" strokeWidth={strokeWidth} />
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" strokeWidth={strokeWidth} />
    <path d="M9 2h6" strokeWidth={strokeWidth} />
    <circle cx="12" cy="8" r="1" strokeWidth={strokeWidth} />
  </>
))
